interface Product {
  name: string;
  description?: string;
  original_price: number;
  discounted_price: number;
  discount_rate: number;
  stock_quantity: number;
}

interface AvailabilityStatus {
  text: string;
  className: string;
  isAvailable: boolean;
  reason: string;
}

interface DesktopProductInfoProps {
  product: Product;
  orderType: string;
  availabilityStatus: AvailabilityStatus;
}

export function DesktopProductInfo({ product, orderType, availabilityStatus }: DesktopProductInfoProps) {
  return (
    <div className="space-y-6">
      {/* Order Type and Status Badges */}
      <div className="flex items-center gap-3">
        <span className="text-lg bg-green-100 text-green-800 px-4 py-2 rounded-lg font-medium">
          {orderType}
        </span>
        <span className={`text-lg px-4 py-2 rounded-lg font-medium ${availabilityStatus.className}`}>
          {availabilityStatus.text}
        </span>
      </div>
      
      {/* Product Name */}
      <h1 className="text-4xl font-bold text-gray-900">{product.name}</h1>
      
      {/* Stock and Price Section */}
      <div className="bg-gray-50 rounded-2xl p-6 space-y-4">
        {/* Stock Information */}
        {orderType === 'RESERVATION_DISCOUNT' ? (
          <div className="flex items-center justify-between">
            <span className="text-xl text-gray-600">상태</span>
            <span className="text-xl font-bold text-green-600">예약 가능</span>
          </div>
        ) : (
          <div className="flex items-center justify-between">
            <span className="text-xl text-gray-600">재고</span>
            <div className="flex items-center gap-2">
              <span className={`text-xl font-bold ${
                product.stock_quantity === 0 ? 'text-red-600' : 
                product.stock_quantity === 1 ? 'text-red-500' : 
                product.stock_quantity < 5 ? 'text-yellow-600' : 'text-green-600'
              }`}>
                {product.stock_quantity === 0 ? '품절' : `${product.stock_quantity}개`}
              </span>
            </div>
          </div>
        )}
        
        {/* Price Information */}
        <div className="space-y-2">
          <div className="flex items-center justify-between">
            {product.discount_rate > 0 && (
              <>
                <span className="text-xl text-gray-500 line-through">
                  {product.original_price.toLocaleString()}원
                </span>
                <span className="text-xl font-bold text-red-600">
                  {product.discount_rate}% 할인
                </span>
              </>
            )}
          </div>
          <div className="flex items-center justify-between border-t pt-2">
            <span className="text-2xl font-medium text-gray-600">할인가</span>
            <span className="text-3xl font-bold text-green-600">
              {product.discounted_price.toLocaleString()}원
            </span>
          </div>
        </div>
      </div>

      {/* Product Description */}
      {product.description && (
        <div className="bg-white border-2 border-gray-200 rounded-2xl p-6">
          <h3 className="text-xl font-bold mb-4 text-gray-900">상품 설명</h3>
          <p className="text-lg text-gray-700 leading-relaxed whitespace-pre-wrap">
            {product.description}
          </p>
        </div>
      )}
    </div>
  );
}